/*
 * Models for the mini learner
 */

define([
  "backbone",
  "jquery",
  "messaging/messenger",
  "modules/shared/sortableList/sortableListModel",
], function (Backbone, $, Messenger, SortableListModel) {
  /*
   * Headers for the mini learner sortable list
   */
  Messenger.reqres.setHandler(
    "mini:learner:headers",
    function () {
      var Header = SortableListModel.headerModel;
      return new Backbone.Collection([
        new Header({
          headerName: $.t("learner.headers.question"),
          modelAttribute: "userUtterance",
          selectable: true,
          textField: true,
          draggable: true,
        }),
      ]);
    },
    this,
  );

  /*
   * Headers for the mini learner sortable list with clusters
   */
  Messenger.reqres.setHandler(
    "mini:learner:clustered:headers",
    function () {
      var Header = SortableListModel.headerModel;
      return new Backbone.Collection([
        new Header({
          headerName: $.t("learner.headers.question"),
          modelAttribute: "userUtterance",
          selectable: true,
          textField: true,
          draggable: true,
        }),
        new Header({
          headerName: $.t("learner.headers.count"),
          modelAttribute: "count",
          numericField: true,
        }),
      ]);
    },
    this,
  );
});
